import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, Type} from "@angular/core";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {Subscription} from "rxjs";
import {EntityData} from "@fedeltapointofsale/data-client";
import {AddRowActionComponent} from "./add-row-action.component";
import {EditGridAddRowNewSelectResults, EditGridAddRowService} from "../edit-grid-add-row.service";
import {EditParams} from "../../../edit-page/edit-params";
import {EditMode} from "../../../edit-page/edit-mode";
import {AnalyticsService} from "../../../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../../../analytics/analytic-event";
import {RoutingDiscoveryService} from "../../../../../../routing-discovery.service";

@Component({
    selector: "wbo-edit-grid-add-row-new-entity",
    template: "",
    providers: [
        {provide: AddRowActionComponent, useExisting: forwardRef(() => EditGridAddRowNewEntityComponent), multi: true}
    ]
})
export class EditGridAddRowNewEntityComponent extends AddRowActionComponent implements OnInit, OnDestroy {
    @Input() editComponent: Type<any>;
    @Input() editPath: string;
    @Input() editParams: any;
    @Input() parentEntity: any;
    @Input() title: string = "wbo.edit.grid.add.addNewEntity";

    @Output() onSelect: EventEmitter<EntityData<any>> = new EventEmitter<EntityData<any>>();

    private subscriptions: Subscription = new Subscription();

    constructor(private stackedPageService: FUIStackedPageService,
                private editGridAddRowService: EditGridAddRowService,
                private analyticsService: AnalyticsService,
                private routingDiscoveryService: RoutingDiscoveryService) {
        super();
    }

    ngOnInit(): void {
        if (this.editPath && !this.editComponent) {
            this.editComponent = this.routingDiscoveryService.findRoutingComponent(this.editPath);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    override click(): void {
        this.newEntity()
    }

    newEntity(): void {
        this.subscriptions.add(this.stackedPageService
            .open(this.editComponent, new EditParams(undefined, EditMode.ADD, this.parentEntity, this.editParams))
            .subscribe((entity: EntityData<any>) => {
                this.onSelect.next(entity);
                this.editGridAddRowService.addNewSelect(new EditGridAddRowNewSelectResults(entity));
            })
        );

        this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_ADD_NEW);
    }
}
